<template>
  <div class="settings">
    <v-container fluid class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="10">
          <v-btn @click="loadFromGS">Load image</v-btn>
          <v-img v-if="img_src" :src="img_src" height="200px" width="200px"></v-img>
          <h3>{{img_src}}</h3>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { storage } from "@/plugins/firebase.js";

export default {
  name: "Test",
  title: "Test",

  data() {
    return {
      img_src: "https://thispersondoesnotexist.com/image"
    };
  },
  methods: {
    async loadFromGS() {
      try {
        const url = await storage
          .refFromURL(
            "gs://techsoup-together-frontend-dev.appspot.com/speakers/VKLmvBi71WqGRh0n6iAB/speaker_image-original"
          )
          .getDownloadURL();
        console.log(url);
        this.img_src = url;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
</style>